import { MAX_MUTES, MAX_TOPICS, editTopics, moveBefore, orderCategories, UNCATEGORIZED, type TopicEdit, muteWord } from "@vladrss/core";
import type { OptimisticLocalStore } from "convex/browser";
import type { Look } from "./prefs";
import { api } from "./api";

/** Convex reapplies pending word edits over each new answer and rolls back refused edits. */
export function optimisticMute(store: OptimisticLocalStore, args: { token: string; word: string; muted: boolean }) {
  const query = { token: args.token };
  const settings = store.getQuery(api.settings.get, query);
  const word = muteWord(args.word);
  if (!settings || !word) return;
  const mutes = args.muted ? [...new Set([...settings.mutes, word])] : settings.mutes.filter((m) => m !== word);
  if (mutes.length <= MAX_MUTES) store.setQuery(api.settings.get, query, { ...settings, mutes });
}

/** Protect only the fields being edited, leaving other devices' independent choices visible. */
export function optimisticLook(store: OptimisticLocalStore, args: { token: string; look: Partial<Look> }) {
  const query = { token: args.token };
  const settings = store.getQuery(api.settings.get, query);
  if (!settings) return;
  const base: Look = { theme: "system", palette: "sage", black: false, order: "oldest", group: "time" };
  store.setQuery(api.settings.get, query, { ...settings, look: { ...base, ...settings.look, ...args.look } });
}

export function optimisticTopic(store: OptimisticLocalStore, args: { token: string; edit: TopicEdit }) {
  const query = { token: args.token }, settings = store.getQuery(api.settings.get, query);
  if (!settings) return;
  const topics = editTopics(settings.topics, args.edit);
  if (topics.length <= MAX_TOPICS) store.setQuery(api.settings.get, query, { ...settings, topics });
}
export function optimisticCategoryOrder(store: OptimisticLocalStore, args: { token: string; name: string; before: string | null }) {
  const query = { token: args.token }, settings = store.getQuery(api.settings.get, query);
  const feeds = store.getQuery(api.feeds.list, query);
  if (!settings || !feeds) return;
  const names = orderCategories(feeds.filter((f) => !f.deleted).map((f) => f.category), settings.categories).filter((n) => n !== UNCATEGORIZED);
  store.setQuery(api.settings.get, query, { ...settings, categories: moveBefore(names, args.name, args.before) });
}
export function optimisticFeedCategory(store: OptimisticLocalStore, args: { token: string; id: string; category: string }) {
  const query = { token: args.token }, feeds = store.getQuery(api.feeds.list, query);
  if (feeds) store.setQuery(api.feeds.list, query, feeds.map((f) => f.id === args.id ? { ...f, category: args.category } : f));
}
